export default __webpack_public_path__ + "static/media/i-external-green.a19a01eb.svg";